import { cn } from "@/lib/utils"

/**
 * A loading placeholder in the shape of the content it stands in for —
 * a slow, flat breathing pulse (no shimmer gradient) that stops under
 * reduced motion. Mirror the real layout; never a spinner mid-page.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "breathe rounded-md bg-surface-raised shadow-[inset_0_0_0_1px_var(--line)]",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
